
import { defineComponent } from 'vue'
import TodoCard from '@/components/TodoCard.vue'
import Services from '@/services/todos'
import { TodoItem } from '@/types'

export default defineComponent({
	name: 'TodoList',

	data() {
		return {
			todos: [] as TodoItem[],
			loading: true
		}
	},

	components: {
		TodoCard,
	},

	mounted() {

		Services.getTodos()
			.then(res => {
				this.todos = res.data
			})
			.catch(rej => {
				console.log(rej)
			})
			.then(() => this.loading = false)
	}
})
